<header class="flex header">
  <h2>
    {{ parameter?.id ? ('Parameter_Modal_Edit' | translateWF: 'Edit Parameter') : ('Parameter_Modal_Add' | translateWF: 'Add Parameter') }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <form [formGroup]="fromGroup">
    <div class="form-box">
      <label for="">{{ 'Parameter_Name' | translateWF: 'Name' }}</label>
      <input class="w-full" type="text" formControlName="name" pInputText />
    </div>
    @if (showPascalError) {
      <p-message severity="secondary">
        <div>
          <span class="error-msg">
            <b>{{ 'Parameter_Modal_Name_Error' | translateWF: 'Make sure that the name does not contain:' }}</b>
          </span>
          <ul class="error-msg">
            <li>
              -
              {{ 'Parameter_Modal_Error_Lowercase' | translateWF: 'Lowercase initial letter' }}
            </li>
            <li>- {{ 'Parameter_Modal_Error_Spaces' | translateWF: 'Spaces' }}</li>
            <li>
              -
              {{ 'Parameter_Modal_Error_Special' | translateWF: 'Special characters' }}
            </li>
            <li>
              <b>{{ 'Parameter_Modal_Error_Example' | translateWF: 'Correct example:' }}</b>
              MyParameterName
            </li>
          </ul>
        </div>
      </p-message>
    }

    <div class="form-box">
      <label for="">{{ 'Parameter_Friendly_Name' | translateWF: 'Friendly Name' }}</label>
      <input class="w-full" type="text" formControlName="friendlyName" pInputText />
    </div>
    <div class="form-box">
      <label for="">{{ 'Parameter_Type' | translateWF: 'Parameter Type' }}</label>
      <p-select [options]="_setOptionsForPrimeNg(parameterTypes)" formControlName="parameterType" class="w-full" />
      <!-- <select formControlName="parameterType">
        <option value="string">Select Type</option>
        <option [value]="type" *ngFor="let type of parameterTypes">
          {{ type }}
        </option>
      </select> -->
    </div>
  </form>
</section>
<footer>
  <p-button class="w-full" [label]="'Common_Save' | translateWF: 'Save'" [disabled]="fromGroup.invalid || showPascalError || !canEdit" (click)="onSave()" />
  <p-button class="w-full" [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onClose()" />
</footer>
